import { TGetMaintenanceDto } from "@/api/services/global/maintenance/dtos/get-maintenance.dto";
import { AppRoutes, LoginRoutes } from "@/routes/config";
import { MAINTENANCE_MODE } from "@/types/enum";
import { dayjs } from "@/utils/dayjs";

const isExemptFromReadableMode = (pathname: string) =>
  pathname === AppRoutes.home || pathname === AppRoutes.contact || LoginRoutes.some((path: string) => pathname.startsWith(path));

const isMaintenanceWindowActive = (data: TGetMaintenanceDto) => {
  if (data.modeStartDateTime && dayjs().tz("Asia/Tokyo").isBefore(dayjs(data.modeStartDateTime).tz("Asia/Tokyo"))) {
    return false;
  }
  if (data.modeEndDateTime && dayjs().tz("Asia/Tokyo").isAfter(dayjs(data.modeEndDateTime).tz("Asia/Tokyo"))) {
    return false;
  }
  return true;
};

/** Pages that must stay reachable regardless of maintenance state (incl. while it is still loading). */
export const isMaintenanceExemptPath = (pathname: string) =>
  pathname.startsWith(AppRoutes.serverErrorPage) || pathname.startsWith(AppRoutes.pageNotFound);

export const resolveMaintenanceRedirect = (data: TGetMaintenanceDto | undefined, pathname: string): string | null => {
  if (isMaintenanceExemptPath(pathname)) return null;

  if (!data?.maintenanceMode || data.maintenanceMode === MAINTENANCE_MODE.SYSTEM_NORMAL_OPERATION) {
    return pathname.startsWith(AppRoutes.maintenance) ? AppRoutes.home : null;
  }

  if (!isMaintenanceWindowActive(data)) return null;

  if (data.maintenanceMode === MAINTENANCE_MODE.MAINTENANCE_UNUSABLE) {
    return pathname.startsWith(AppRoutes.maintenance) ? null : AppRoutes.maintenance;
  }

  if (data.maintenanceMode === MAINTENANCE_MODE.MAINTENANCE_READABLE) {
    return isExemptFromReadableMode(pathname) ? null : AppRoutes.home;
  }

  return pathname === AppRoutes.maintenance ? AppRoutes.home : null;
};
